export const sortKanaDesc = (key: string) => (a: any, b: any) => a[key].localeCompare(b[key], 'ja')
